import { format, parse } from "date-fns";
import { de } from "date-fns/locale";
import { GuestBreakdown } from "./GuestSummary";

export const ReceiptPrintTemplate = ({ reservation }) => (
  <div style={{ 
    width: '80mm', 
    maxWidth: '80mm', 
    fontFamily: 'Arial, Helvetica, sans-serif', 
    fontSize: '28pt', 
    padding: '8mm',
    lineHeight: '2.2',
    fontWeight: '600',
    color: '#000'
  }}>
    {/* Header */}
    <div style={{ textAlign: 'center', borderBottom: '5px dashed #000', paddingBottom: '12mm', marginBottom: '10mm' }}>
      <div style={{ fontSize: '42pt', fontWeight: 'bold', letterSpacing: '3px', color: '#000' }}>PIZZERIA PIAZZA</div>
      <div style={{ fontSize: '28pt', marginTop: '4mm', color: '#000' }}>Zürich Affoltern</div>
      <div style={{ fontSize: '36pt', fontWeight: 'bold', marginTop: '8mm', letterSpacing: '4px', color: '#000' }}>RESERVIERUNG</div>
    </div>
    
    {/* Status */}
    <div style={{ textAlign: 'center', marginBottom: '10mm', fontSize: '34pt', fontWeight: 'bold', letterSpacing: '3px', color: '#000' }}>
      {reservation.status === 'pending' ? 'ANFRAGE' : 'BESTÄTIGT'}
    </div>
    
    {/* Reservation Details */}
    <div style={{ marginBottom: '10mm' }}>
      <table style={{ width: '100%', fontSize: '28pt', borderSpacing: '0' }}>
        <tbody>
          <tr>
            <td style={{ padding: '5mm 0', fontSize: '28pt', color: '#000' }}>Datum:</td>
            <td style={{ textAlign: 'right', fontWeight: 'bold', fontSize: '32pt', color: '#000' }}>
              {format(parse(reservation.reservation_date, "yyyy-MM-dd", new Date()), "dd.MM.yyyy", { locale: de })}
            </td>
          </tr>
          <tr>
            <td style={{ padding: '5mm 0', fontSize: '28pt', color: '#000' }}>Uhrzeit:</td>
            <td style={{ textAlign: 'right', fontWeight: 'bold', fontSize: '34pt', color: '#000' }}>{reservation.reservation_time}</td>
          </tr>
          <tr>
            <td style={{ padding: '5mm 0', fontSize: '28pt', color: '#000' }}>Personen:</td>
            <td style={{ textAlign: 'right', fontWeight: 'bold', fontSize: '38pt', color: '#000' }}>{reservation.guests_count}</td>
          </tr>
        </tbody>
      </table>
      <div style={{ fontSize: '18pt', lineHeight: '1.4' }}>
        <GuestBreakdown reservation={reservation} prefix="receipt-print" />
      </div>
    </div>
    
    <div style={{ borderTop: '4px dashed #000', borderBottom: '4px dashed #000', padding: '6mm 0', marginBottom: '10mm' }}>
      <div style={{ fontWeight: 'bold', marginBottom: '5mm', fontSize: '32pt', color: '#000' }}>KUNDE:</div>
      <div style={{ fontSize: '28pt', marginBottom: '4mm', fontWeight: 'bold', color: '#000' }}>{reservation.first_name} {reservation.last_name}</div>
      <div style={{ fontSize: '28pt', marginBottom: '4mm', fontWeight: 'bold', color: '#000' }}>{reservation.phone}</div>
      <div style={{ fontSize: '22pt', wordBreak: 'break-all', lineHeight: '1.8', color: '#000' }}>{reservation.email}</div>
    </div>
    
    {reservation.special_requests && (
      <div style={{ borderBottom: '4px dashed #000', padding: '6mm 0', marginBottom: '10mm' }}>
        <div style={{ fontWeight: 'bold', marginBottom: '5mm', fontSize: '32pt', color: '#000' }}>WÜNSCHE:</div>
        <div style={{ fontSize: '26pt', fontStyle: 'italic', lineHeight: '1.9', color: '#000' }}>{reservation.special_requests}</div>
      </div>
    )}
    
    {reservation.attachment_filename && (
      <div style={{ borderBottom: '4px dashed #000', padding: '6mm 0', marginBottom: '10mm' }}>
        <div style={{ fontWeight: 'bold', fontSize: '28pt', color: '#000' }}>ANHANG:</div>
        <div style={{ fontSize: '24pt', marginTop: '4mm', color: '#000' }}>{reservation.attachment_filename}</div>
      </div>
    )}
    
    {/* Footer */}
    <div style={{ textAlign: 'center', fontSize: '24pt', marginTop: '10mm', color: '#000' }}>
      <div style={{ marginBottom: '5mm', fontSize: '20pt' }}>ID: {reservation.id.substring(0, 8)}</div>
      <div style={{ marginBottom: '5mm', fontSize: '24pt' }}>{format(new Date(), "dd.MM.yyyy HH:mm", { locale: de })}</div>
      <div style={{ marginTop: '8mm', borderTop: '4px solid #000', paddingTop: '6mm', fontSize: '26pt' }}>
        info@pizza-piazza.ch
      </div>
      <div style={{ fontSize: '32pt', marginTop: '4mm', fontWeight: 'bold' }}>+41 44 500 20 44</div>
    </div>
  </div>
);

export const A4PrintTemplate = ({ reservation }) => (
  <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
    <div style={{ textAlign: 'center', marginBottom: '30px', borderBottom: '3px solid #c8232c', paddingBottom: '20px' }}>
      <h1 style={{ color: '#c8232c', fontSize: '32px', margin: '0 0 10px 0' }}>🍕 Pizzeria Piazza</h1>
      <p style={{ color: '#666', fontSize: '18px', margin: 0 }}>Zürich Affoltern</p>
      <h2 style={{ color: '#2c2c2c', fontSize: '24px', marginTop: '20px' }}>NEUE RESERVIERUNG</h2>
    </div>
    
    <div style={{ backgroundColor: '#f8f6f3', padding: '20px', borderRadius: '10px', marginBottom: '20px' }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', fontSize: '16px' }}>
        <div>
          <p style={{ color: '#666', margin: '0 0 5px 0', fontSize: '14px' }}>DATUM:</p>
          <p style={{ fontSize: '20px', fontWeight: 'bold', margin: 0 }}>
            {format(parse(reservation.reservation_date, "yyyy-MM-dd", new Date()), "dd.MM.yyyy", { locale: de })}
          </p>
        </div>
        <div>
          <p style={{ color: '#666', margin: '0 0 5px 0', fontSize: '14px' }}>UHRZEIT:</p>
          <p style={{ fontSize: '20px', fontWeight: 'bold', margin: 0 }}>
            {reservation.reservation_time} Uhr
          </p>
        </div>
        <div>
          <p style={{ color: '#666', margin: '0 0 5px 0', fontSize: '14px' }}>PERSONEN:</p>
          <p style={{ fontSize: '20px', fontWeight: 'bold', margin: 0 }}>
            {reservation.guests_count}
          </p>
          <GuestBreakdown reservation={reservation} prefix="a4-print" />
        </div>
        <div>
          <p style={{ color: '#666', margin: '0 0 5px 0', fontSize: '14px' }}>STATUS:</p>
          <p style={{ 
            fontSize: '16px', 
            fontWeight: 'bold', 
            margin: 0,
            color: reservation.status === 'pending' ? '#f59e0b' : '#10b981',
            textTransform: 'uppercase'
          }}>
            {reservation.status === 'pending' ? '⚠️ ANFRAGE' : '✓ BESTÄTIGT'}
          </p>
        </div>
      </div>
    </div>
    
    <div style={{ border: '2px solid #c8232c', padding: '20px', borderRadius: '10px', marginBottom: '20px' }}>
      <h3 style={{ color: '#c8232c', marginTop: 0, fontSize: '20px' }}>KUNDENDATEN</h3>
      <table style={{ width: '100%', fontSize: '16px' }}>
        <tbody>
          <tr>
            <td style={{ padding: '8px 0', color: '#666', width: '40%' }}>Name:</td>
            <td style={{ padding: '8px 0', fontWeight: 'bold' }}>
              {reservation.first_name} {reservation.last_name}
            </td>
          </tr>
          <tr>
            <td style={{ padding: '8px 0', color: '#666' }}>Telefon:</td>
            <td style={{ padding: '8px 0', fontWeight: 'bold' }}>{reservation.phone}</td>
          </tr>
          <tr>
            <td style={{ padding: '8px 0', color: '#666' }}>E-Mail:</td>
            <td style={{ padding: '8px 0', fontWeight: 'bold' }}>{reservation.email}</td>
          </tr>
        </tbody>
      </table>
    </div>
    
    {reservation.special_requests && (
      <div style={{ backgroundColor: '#fff3cd', padding: '15px', borderRadius: '10px', marginBottom: '20px', border: '2px solid #ffc107' }}>
        <h3 style={{ color: '#856404', marginTop: 0, fontSize: '18px' }}>💬 SPEZIELLE WÜNSCHE</h3>
        <p style={{ margin: 0, fontSize: '16px', color: '#856404', fontStyle: 'italic' }}>
          "{reservation.special_requests}"
        </p>
      </div>
    )}
    
    {reservation.attachment_filename && (
      <div style={{ backgroundColor: '#e0f2fe', padding: '15px', borderRadius: '10px', marginBottom: '20px', border: '2px solid #0284c7' }}>
        <p style={{ margin: 0, fontSize: '16px', color: '#0c4a6e' }}>
          📎 <strong>Anhang vorhanden:</strong> {reservation.attachment_filename}
        </p>
      </div>
    )}
    
    <div style={{ marginTop: '30px', paddingTop: '20px', borderTop: '2px dashed #ccc', textAlign: 'center' }}>
      <p style={{ color: '#666', fontSize: '14px', margin: '5px 0' }}>
        Reservierungs-ID: {reservation.id}
      </p>
      <p style={{ color: '#666', fontSize: '14px', margin: '5px 0' }}>
        Gedruckt: {format(new Date(), "dd.MM.yyyy HH:mm", { locale: de })} Uhr
      </p>
      <p style={{ color: '#c8232c', fontSize: '16px', fontWeight: 'bold', marginTop: '15px' }}>
        Pizzeria Piazza • Zürich Affoltern • info@pizza-piazza.ch
      </p>
    </div>
  </div>
);
